import { useState, useLayoutEffect } from 'react';

export const useWidth = () => {
  const [width, setWidth] = useState<number>(0);

  useLayoutEffect(() => {
    setWidth(document.documentElement.clientWidth);
    const widthCallback = () => setWidth(document.documentElement.clientWidth);
    window.addEventListener('resize', widthCallback);

    return () => {
      window.removeEventListener('resize', widthCallback);
    };
  }, []);

  return width;
};
